import { CheckCircleOutlined } from '@ant-design/icons'
import { Progress, Tag, Tooltip } from 'antd'
import { round } from 'lodash'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { PAGE_RESOURCE_POINTS_ENUM, Project } from '@/schemas'

import { MosaicComponent, getPointPermission } from './permission.component'

interface ProjectProgressProps {
  project: Project
}

export const ProjectProgress: React.FC<ProjectProgressProps> = ({ project }) => {
  const { t } = useTranslation()
  const { canRead } = getPointPermission(PAGE_RESOURCE_POINTS_ENUM.概况_进度, project.permissions)

  if (!canRead) {
    return <MosaicComponent />
  }

  if (project.status === 2) {
    if (!project.evaluation) {
      return <span>{t('evaluation.nodata')}</span>
    }
    return (
      <Tooltip title={t('evaluation.completion') + ` ${t('progress')}: ${project.progress}`}>
        <Tag color='success' icon={<CheckCircleOutlined />}>
          {project.evaluation.completion}
        </Tag>
      </Tooltip>
    )
  } else {
    return (
      <Tooltip title={t('progress') + ` ${project.progress}`}>
        <Progress
          className='flex-shrink-0 font-mono'
          type='circle'
          width={26}
          percent={round(project.progress ?? 0, 0)}
        />
      </Tooltip>
    )
  }
}
